import type { Field, RefName, Row } from "./types";

const brl = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

/** Coluna que o backend devolve com o nome do registro referenciado. */
const REF_LABEL: Record<RefName, string> = {
  colaboradores: "colaborador_nome",
  obras: "obra_nome",
  equipamentos: "equipamento_nome",
};

export function formatCurrency(value: unknown): string {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  return Number.isNaN(n) ? "—" : brl.format(n);
}

export function formatDate(value: unknown): string {
  if (!value) return "—";
  const d = new Date(value as string);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString("pt-BR", { timeZone: "UTC" });
}

/** Formata o valor de uma célula conforme o tipo do campo. */
export function formatCell(field: Field, row: Row): string {
  if (field.ref) {
    return row[REF_LABEL[field.ref]] ?? "—";
  }
  const value = row[field.name];
  if (value === null || value === undefined || value === "") return "—";
  switch (field.type) {
    case "currency":
      return formatCurrency(value);
    case "date":
      return formatDate(value);
    case "password":
      return "••••••";
    default:
      return String(value);
  }
}

/** Classe de cor (pílula) para um valor de status, conforme o texto. */
export function statusTone(value: string): string {
  const v = value.toLowerCase();
  if (
    ["vencid", "atrasad", "bloqueado", "cancelad", "insatisfeito", "aberto", "pendente", "grave", "óbito", "obito", "zerado", "abaixo do"].some((s) =>
      v.includes(s),
    )
  )
    return "danger";
  if (
    ["a vencer", "a reciclar", "vence hoje", "revisão próxima", "revisao proxima", "em andamento", "em manutenção", "em correção", "em calibração", "em tratamento", "em separação", "em separacao", "agendada", "agendado", "planejada", "neutro", "afastado", "registrado", "moderado", "parado"].some(
      (s) => v.includes(s),
    )
  )
    return "warn";
  if (
    ["válid", "valid", "em dia", "no prazo", "ativo", "ativa", "em atividade", "disponível", "disponivel", "autorizado", "liberado", "devolvido", "concluíd", "concluid", "executada", "resolvido", "satisfeito", "encerrado", "leve", "sem lesão", "sem lesao", "pago"].some(
      (s) => v.includes(s),
    )
  )
    return "ok";
  return "neutral";
}
